import { z } from 'zod';

export const GranolaStatusSchema = z.object({
	status: z.enum(['connected', 'expired', 'not_connected']),
});
export type GranolaStatus = z.infer<typeof GranolaStatusSchema>;

export const GranolaAuthorizeSchema = z.object({
	redirectUrl: z.string(),
});
export type GranolaAuthorize = z.infer<typeof GranolaAuthorizeSchema>;

export const GranolaDisconnectSchema = z.object({
	disconnected: z.boolean(),
});
export type GranolaDisconnect = z.infer<typeof GranolaDisconnectSchema>;
